import { render } from "./NotificationAreaComp.vue?vue&type=template&id=64d3a758"
import script from "./NotificationAreaComp.vue?vue&type=script&lang=js"
export * from "./NotificationAreaComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__